import { Button } from "@/shared/components/common/Button/Button"
import { useState } from "react";
import ActionPopup from "../../_popups/ActionPopup/ActionPopup";

function PlanActionsButton() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button onClick={() => setOpen(true)}>
      <span>Планы продаж</span>
    </Button>

      <ActionPopup open={open} onClose={() => setOpen(false)} />
    </>
  )
}

export default PlanActionsButton